import { Router } from '@angular/router';
import { FeatureSettingsService } from '../feature-settings/feature-settings.service';
import { MaintenanceComponent } from 'src/app/pages/maintenance/maintenance.component';

/**
 * Au démarrage du site client, lit l'état de maintenance réglé dans l'administration vendeur.
 * En maintenance, toutes les routes mènent à l'écran de maintenance : aucune page, aucun garde
 * (connexion CIAM, jeton HomeByMe…) ne s'exécute. Le routeur ne navigue qu'une fois les
 * initialiseurs terminés, la configuration est donc remplacée avant la première navigation.
 */
export function customerMaintenanceInitializer(featureSettings: FeatureSettingsService, router: Router) {
  return async (): Promise<void> => {
    if (await featureSettings.isCustomerMaintenance()) {
      router.resetConfig([{ path: '**', component: MaintenanceComponent, data: { hideHeader: true } }]);
    }
  };
}
